(() => {
  'use strict';
  if (window.__pplRealPhotoReviews) return;
  window.__pplRealPhotoReviews = true;
  document.documentElement.classList.add('ppl-real-reviews-js');
  const initialized = new WeakSet();
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
  // Keep keyboard focus on a usable arrow when the focused one is about to be disabled.
  function setArrows(previous, next, previousOff, nextOff) {
    if (!previousOff) previous.disabled = false;
    if (!nextOff) next.disabled = false;
    const active = document.activeElement;
    if (nextOff && active === next && !previousOff) previous.focus({ preventScroll: true });
    if (previousOff && active === previous && !nextOff) next.focus({ preventScroll: true });
    previous.disabled = previousOff;
    next.disabled = nextOff;
  }
  function initialize(section) {
    if (initialized.has(section)) return;
    initialized.add(section);
    const dialog = section.querySelector('[data-real-review-modal]');
    let lastTrigger;
    const close = () => dialog.close();
    section.querySelector('[data-real-review-close]').addEventListener('click', close);
    dialog.addEventListener('close', () => {
      if (lastTrigger?.isConnected) lastTrigger.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
    });
    section.querySelectorAll('[data-real-review-open]').forEach(button => button.addEventListener('click', () => {
      const card = button.closest('[data-real-review-card]');
      const photo = card.querySelector('.real-review-photo img');
      const source = card.querySelector('[data-real-review-source-url]');
      const product = card.querySelector('[data-real-review-product-url]');
      dialog.querySelector('[data-real-review-modal-name]').textContent = card.dataset.realReviewName;
      dialog.querySelector('[data-real-review-modal-product]').textContent = card.querySelector('[data-real-review-product]')?.textContent || '';
      dialog.querySelector('[data-real-review-modal-source-label]').textContent = card.querySelector('[data-real-review-source-label]')?.textContent || '';
      const image = dialog.querySelector('[data-real-review-modal-image]');
      image.closest('.real-review-modal-photo').hidden = !photo;
      if (photo) { image.src = photo.currentSrc || photo.src; image.alt = photo.alt; }
      dialog.querySelector('[data-real-review-modal-body]').textContent = card.querySelector('[data-real-review-full]').textContent.replace(/\n{3,}/g, '\n\n');
      const sourceLink = dialog.querySelector('[data-real-review-modal-source]');
      sourceLink.hidden = !source;
      if (source) sourceLink.setAttribute('href', source.getAttribute('href'));
      else sourceLink.removeAttribute('href');
      const productLink = dialog.querySelector('[data-real-review-modal-product-link]');
      productLink.hidden = !product;
      if (product) { productLink.setAttribute('href', product.getAttribute('href')); productLink.textContent = product.textContent; }
      else { productLink.removeAttribute('href'); productLink.textContent = ''; }
      lastTrigger = button;
      dialog.showModal();
      dialog.scrollTop = 0;
      dialog.querySelector('[data-real-review-close]').focus();
    }));
    const rail = section.querySelector('[data-real-review-rail]');
    const controls = section.querySelector('[data-real-review-controls]');
    const previous = controls.querySelector('[data-real-review-direction="-1"]');
    const next = controls.querySelector('[data-real-review-direction="1"]');
    const position = controls.querySelector('[data-real-review-position]');
    const cards = () => [...rail.querySelectorAll('[data-real-review-card]')];
    function metrics() {
      const items = cards();
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 19;
      const stride = items.length ? items[0].getBoundingClientRect().width + gap : 1;
      return { total: items.length, stride, visible: Math.max(1, Math.floor((rail.clientWidth + gap + 1) / stride)), start: Math.max(0, Math.round(rail.scrollLeft / stride)), scrollable: rail.scrollWidth > rail.clientWidth + 2 };
    }
    function update() {
      const m = metrics();
      const start = Math.min(Math.max(0, m.total - 1), m.start);
      controls.hidden = !m.scrollable || m.total < 2;
      position.textContent = m.total ? `${start + 1}${m.visible > 1 ? '–' + Math.min(m.total, start + m.visible) : ''} ${position.dataset.countOf || 'of'} ${m.total}` : '';
      setArrows(previous, next, !m.scrollable || rail.scrollLeft < 2, !m.scrollable || rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2);
    }
    function move(direction) {
      const m = metrics();
      rail.scrollBy({ left: direction * m.stride * m.visible, behavior: motion() });
    }
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', update, { passive: true });
    rail.addEventListener('keydown', event => {
      if (event.target === rail && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
        event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1);
      }
    });
    if (typeof ResizeObserver === 'function') {
      const observer = new ResizeObserver(update);
      observer.observe(rail);
      section.addEventListener('ppl:real-reviews-unload', () => observer.disconnect(), { once: true });
    }
    update();
    section.querySelectorAll('video').forEach(video => video.addEventListener('play', () => section.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); })));
    const lazyVideos = [...section.querySelectorAll('video[data-real-video]')];
    const loadVideo = video => { if (video.preload === 'none') { video.preload = 'metadata'; video.load(); } };
    if (lazyVideos.length && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { loadVideo(entry.target); io.unobserve(entry.target); } }), { rootMargin: '600px' });
      lazyVideos.forEach(video => io.observe(video));
      section.addEventListener('ppl:real-reviews-unload', () => io.disconnect(), { once: true });
    } else lazyVideos.forEach(loadVideo);
  }
  const scan = scope => {
    if (scope.matches?.('[data-ppl-real-reviews]')) initialize(scope);
    scope.querySelectorAll('[data-ppl-real-reviews]').forEach(initialize);
  };
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ppl-real-reviews]').forEach(section => section.dispatchEvent(new Event('ppl:real-reviews-unload'))));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
})();
